import * as logger from '@xhs/logger'

logger.configure({
  transport: {
    // default to disable logger in non-developmenet env
    console: (process.env.NODE_ENV !== 'production' || !process.env.BROWSER),

    // transport to sentry only if in production env
    sentry: process.env.NODE_ENV === 'production',

    // transport to apm only if in production env
    eaglet: process.env.NODE_ENV === 'production',
  },
})

function formatComponentName(vm) {
  /* eslint-disable no-underscore-dangle */

  if (vm.$root === vm) {
    return 'root instance'
  }

  const name = vm._isVue
    ? vm.$options.name || vm.$options._componentTag
    : vm.name

  const componentName = name ? `component <${name}>` : 'anonymous component'
  const file = vm._isVue && vm.$options.__file
    ? ` at ${vm.$options.__file}`
    : ''

  return `${componentName}${file}`
}

const Logger = {
  name: 'loggerPlugin',
  installed: false,
  install(app, Launcher, options) {
    if (Logger.installed) {
      return
    }

    if (options) {
      logger.configure(options)
    }

    if (app.vm) {
      app.vm.config.errorHandler = (err, vm, info) => {
        const metaData = {}

        // vm and lifecycleHook are not always available
        if (Object.prototype.toString.call(vm) === '[object Object]') {
          metaData.componentName = formatComponentName(vm)
          metaData.propsData = vm.$options.propsData
        }

        if (typeof info !== 'undefined') {
          metaData.lifecycleHook = info
        }

        logger.error(err, metaData)
      }
    }

    app.logger = logger

    Logger.installed = true
  },
  /* eslint-disable */
  create(app, Launcher, ops) {
    if (!process.env.BROWSER) {
      const kibanaLog = app.context?.ssrUtils?.kibanaLog
      Logger.kibanaLog = message => {
        if (kibanaLog) {
          kibanaLog({
            ctx: app.context,
            logArg: {
              message,
              prdline: 'fe_api',
            },
          })
        } else {
          console.error(message)
        }
      }
    }
  },
  ...logger,
}

export default Logger
